export class PostGetPatientVirtualUrgentCareRequest {
    patientId: string | null = null;
    fhirPatientID: string | null = null;
    patientAge: number | null = null;
    maxDisplayCount: number = 3;
}